import { useEffect, useState } from 'react';
import dynamic from 'next/dynamic';
import { useResponsive } from '@features/responsive';
import styles from '@features/homepage/sections/Services/ServicesSection.styles';
import { IServices } from '@features/cms/typescript';
import Heading from '@components/Heading/Heading';
import theme from '@styles/theme';
import SliderImage from '@components/Slider/SliderImage';
type PropsType = {
  services: IServices;
  isFirst?: boolean;
};
const DynamicServicesSectionSlider = dynamic(() => import('./ServicesSectionSlider'), {
  ssr: false
});
const ServicesSection = ({
  services,
  isFirst = false
}: PropsType) => {
  const [slideShow, setSlideShow] = useState(2);
  const {
    isMobile,
    isMobilelg
  } = useResponsive();
  const {
    background,
    blur
  } = services;
  useEffect(() => {
    if (isMobile) {
      setSlideShow(1);
    } else if (isMobilelg) {
      setSlideShow(2);
    } else {
      setSlideShow(4);
    }
  }, [isMobile, isMobilelg]);
  return <section sx={styles.section} data-testid="ServicesSection">
      <div sx={styles.imageContainer} data-cy="ServicesSectionBackground" data-testid="ServicesSectionBackground">
        <SliderImage image={background} blur={blur} priority={isFirst || false} fullHeight />
      </div>
      <div sx={styles.contentStyles} data-testid="ServicesSectionContent">
        <Heading display={isFirst ? 1 : 3} mobile align="center" color={theme.rawColors.neutralWhite}>
          {services.title}
        </Heading>
        <DynamicServicesSectionSlider services={services} slideShow={slideShow} />
      </div>
    </section>;
};
export default ServicesSection;